import type { LstActivityKind, LstTemplate } from '../types';

const REUNIAO_PATTERNS = [
  /reuni[aã]o\s+de\s+camada/i,
  /reuni[aã]o\s+rel[aâ]mpago\s+de\s+camada/i,
  /cadeia\s+de\s+ajuda\s*[-–]\s*reuni[aã]o/i,
];

export function isReuniaoCamada(template: Pick<LstTemplate, 'activity_kind' | 'title'>): boolean {
  if (template.activity_kind === 'reuniao_camada') return true;
  return REUNIAO_PATTERNS.some((re) => re.test(template.title));
}

export function isCadeiaEscalation(template: Pick<LstTemplate, 'title'>): boolean {
  return /escalonad|reuni[aã]o\s+escalonada|cadeia\s+de\s+ajuda/i.test(template.title);
}

export function isAtaColetivaContext(template: Pick<LstTemplate, 'activity_kind' | 'title'>): boolean {
  return isReuniaoCamada(template) || isCadeiaEscalation(template);
}

export function activityKindLabel(kind: LstActivityKind): string {
  return kind === 'reuniao_camada' ? 'Reunião de Camada' : 'Rotina padrão';
}
